import { render, staticRenderFns } from "./SalaryHistory.vue?vue&type=template&id=0e7bbc82&scoped=true&"
import script from "./SalaryHistory.vue?vue&type=script&lang=js&"
export * from "./SalaryHistory.vue?vue&type=script&lang=js&"
import style0 from "./SalaryHistory.vue?vue&type=style&index=0&id=0e7bbc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7bbc82",
  null
  
)

export default component.exports